// @school-apps/core/hours/csv — pure CSV builder for the hour log's Export button (A·1).
// Bundled CLIENT-side (subpath export, like srs/fsrs): the export runs in the browser over
// already-synced records — no endpoint, no server round-trip. Dates/times are LOCAL wall-clock
// (an application form wants "9:00 AM at the clinic", not UTC); durations are the stored
// server-computed minutes. Cells are RFC-4180-escaped (quotes doubled, wrapped when a cell
// carries a comma/quote/newline).

const pad = (n) => String(n).padStart(2, "0");
const localDate = (iso) => { const d = new Date(iso); return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`; };
const localTime = (iso) => { const d = new Date(iso); return `${pad(d.getHours())}:${pad(d.getMinutes())}`; };
const cell = (v) => { const s = String(v ?? ""); return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s; };

/**
 * Render hour-log entries (the /api/hours shape) to a CSV string, entries in the order given.
 * Columns: date, start, end, durationMin, category, place, activity, origin, note.
 * @param {Array<{ startedAt: string, endedAt: string, durationMin: number, category: string,
 *                 place: string, activity?: string, origin: string, note?: string }>} entries
 * @returns {string}
 */
export function hoursCsv(entries) {
  const rows = [["date", "start", "end", "durationMin", "category", "place", "activity", "origin", "note"]];
  for (const e of entries) {
    rows.push([
      localDate(e.startedAt), localTime(e.startedAt), localTime(e.endedAt),
      e.durationMin, e.category, e.place, e.activity ?? "", e.origin, e.note ?? "",
    ]);
  }
  return rows.map((r) => r.map(cell).join(",")).join("\n") + "\n";
}
